import Cookies from 'js-cookie'

const TokenKey = 'token-rnr'
const RnrSourceKey = 'rnr-source'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRnrSource() {
  return Cookies.get(RnrSourceKey)
}

export function setRnrSource(source) {
  return Cookies.set(RnrSourceKey, source)
}

export function removeRnrSource() {
  return Cookies.remove(RnrSourceKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js